import React, { Component } from 'react'; 
import { ColumnType } from '../PhasePlan/Column';
import { PhasePlanStatus } from '../../models/PhasePlan'
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';

import Button from '@material-ui/core/Button';
import { Backlog } from '../PhasePlan/Backlog';
import { TradeCard } from '../PhasePlan/TradeCard';
import { Trade } from '../../models/Trade';
import { dialogActions } from '../../actions/dialog.actions';
import { getTagsByColumns, getTradesList, getTrades, getSelectedPhasePlan } from '../../selectors/phaseplan.selector';
import {  getLookaheadColumnTags, getLookaheadTrades, getLookaheadTradesList, getSelectedLookahead, NewTagType } from '../../selectors/lookahead.selector';
import { lookaheadActions } from '../../actions/lookahead.actions';
import { Typography } from '@material-ui/core';
import { LookaheadTag } from '../../models/LookaheadTag';
import { getUserTrades } from '../../selectors/trade.selector';


interface Props {
  drawerSwitch: String, 
  phaseplanTagsByColumns: any,
  lookaheadTagsByColumn: any,
  tradesList: any,
  trades: any,
  classes: any,
  selectedChartPP: any,
  selectedChartMRP: any,
  draggedTag: any,
  tagsByMilestone:  Record<string, LookaheadTag[]>,
  chartType: String, 
  showTagDialogValue: (tagId?: string) => void,
  openConstraintDialog: (constaintId?: string) => void,
  showTradeDialogValue: (tradeId?: string) => Promise<void>,
  showLookaheadTagDialogValue:  (tagId?: string) => void,
  userTrades: Set<string>,
  isAdmin: boolean,
  isFullScreen: boolean
}


class RightDrawer extends Component<Props>  {

  showTagDialog = async () => {
    const { chartType, showTagDialogValue, showLookaheadTagDialogValue } = this.props; 
    if (chartType == 'phaseplan') showTagDialogValue()
    if (chartType == 'lookahead') showLookaheadTagDialogValue();
  }
  
  showConstraintDialog = async () => {
		this.props.openConstraintDialog()
  }
  
  showTradeDialog = async () => {
		this.props.showTradeDialogValue()
	}

  renderTagBacklog(tags: Tag[]) {
    const { trades, selectedChartPP, chartType, classes, draggedTag, isFullScreen } = this.props
    
		return (
				<Backlog
            isFullScreen={isFullScreen}
						type={ColumnType.PhasePlan} 
						isDisabled={chartType == 'phaseplan' && selectedChartPP.status === PhasePlanStatus.Started}
						classes={classes} 
						tags={tags}
						draggedTag={draggedTag}
						trades={trades} 
						backlogKey={'-1'}
				/>
		)
  }

  renderTagBacklogConstraints(tags: Tag[]) {
		const { trades, selectedChartPP, chartType, classes, draggedTag, isFullScreen} = this.props

		return (
						<Backlog
              isFullScreen={isFullScreen}
							type={ColumnType.PhasePlan} 
							isDisabled={chartType == 'phaseplan' && selectedChartPP.status === PhasePlanStatus.Started}
							classes={classes} 
							tags={tags}
							draggedTag={draggedTag}
							trades={trades} 
							backlogKey={'-2'}
						/>
		)
  }
  

	renderTradeContractorGrid(trade: Trade) {
    const { selectedChartPP, chartType, userTrades, isAdmin } = this.props
    let canEdit = true
    
    if(!!trade.uid) {
      canEdit = (userTrades.has(trade.uid) || !!isAdmin)
    }

    return( 
			<TradeCard  
				isDisabled={!canEdit}	
				trade={trade} 
			/>
		)
	}

  
  render() {
    const { classes, tradesList, drawerSwitch, lookaheadTagsByColumn, phaseplanTagsByColumns, chartType, draggedTag, trades, selectedChartPP, tagsByMilestone, userTrades, isAdmin  } = this.props;

    let tagsBacklog = [];
    let constraintTags = []; 

    if (chartType == 'phaseplan' && phaseplanTagsByColumns['undefined'] !== undefined) {


      tagsBacklog = phaseplanTagsByColumns['undefined'].filter(tag => tag.tagCardType === 'PhasePlanTagType')
			constraintTags = phaseplanTagsByColumns['undefined'].filter(tag => tag.tagCardType === 'ConstraintTagType')
    } 

		if (chartType == 'lookahead') {

      const tags = !!lookaheadTagsByColumn['undefined'] ? lookaheadTagsByColumn['undefined'] : []

      const tagsArr = Object.keys(tags).map((key) => tags[key]);


      const combinedTags = [...tagsArr ]


      tagsBacklog = combinedTags.filter(tag => tag.type == NewTagType.Lookahead || tag.type == NewTagType.Milestone)
			constraintTags = combinedTags.filter(tag => tag.type == NewTagType.Constraint)
    }    


    return (
      <div>

      {
        (drawerSwitch == 'backlog')	? (
          <div className={classes.DrawerContainer}>
            <Typography variant="h7">Tags</Typography>
            <div className={classes.DrawerBacklogContainer}>
              <div style={{width: '80%'}}>

              <Backlog
                  type={ColumnType.Lookahead} 
                  isDisabled={chartType == 'phaseplan' && selectedChartPP.status === PhasePlanStatus.Started}
                  classes={classes} 
                  tagRecords={tagsBacklog}
                  draggedTag={draggedTag}
                  trades={trades} 
                  backlogKey={'-1'}
                  userTrades={userTrades}
							    isAdmin={isAdmin}

              />

              </div>
              <Button 
                variant="outlined" 
                color="primary" 
                onClick={this.showTagDialog} 
                className={classes.DrawerBacklogButton}
                >
                   + 
                </Button>
            </div>

            <br />
            <hr />
            <br />

            <Typography variant="h7">Constraints</Typography>
            <div className={classes.DrawerBacklogContainer}>
              <div style={{width: '80%'}}>
                <Backlog
                  type={ColumnType.Lookahead} 
                  isDisabled={chartType == 'phaseplan' && selectedChartPP.status === PhasePlanStatus.Started}
                  classes={classes} 
                  tagRecords={constraintTags}
                  draggedTag={draggedTag}
                  trades={trades} 
                  backlogKey={'-2'}
                  userTrades={userTrades}
							    isAdmin={isAdmin}
                />
              </div>
                <Button 
                  variant="outlined" 
                  color="primary" 
                  onClick={this.showConstraintDialog}
                  className={classes.DrawerBacklogButton}
                > 
                  + 
                  </Button>
             </div>
          </div>
        ) : (
          <div className={classes.DrawerTradesContainer}>
            <div className={classes.PhasePlanTradeListSection}>
              {tradesList.map(trade => {
                return this.renderTradeContractorGrid(trade)})
              }
            </div>
            <Button 
              variant="outlined" 
              color="primary" 
              onClick={this.showTradeDialog} 
              className={classes.DrawerTradesButton}
            >
            + New Trade
          </Button>
          </div>
          )}	
      </div>
    )
  }
}

const mapStateToProps = (state:any) => ({
  phaseplanTagsByColumns: getTagsByColumns(state),  //phaseplan
  tradesList: getLookaheadTradesList(state),
  trades: getLookaheadTrades(state), 
  selectedChartPP: getSelectedPhasePlan(state),

  lookaheadTagsByColumn: getLookaheadColumnTags(state), // Lookahead
  selectedChartMRP: getSelectedLookahead(state),
})

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => ({
  showTagDialogValue:  (tagId: string) => dispatch(dialogActions.showTagDialog(tagId)),
  openConstraintDialog: (constaintId?: string) => dispatch(dialogActions.openConstraintDialog(constaintId)),
  showTradeDialogValue: (tradeId: string | null) => dispatch(dialogActions.showTradeDialog(tradeId)),
  showLookaheadTagDialogValue: (tagId:string) => dispatch(lookaheadActions.lookaheadDialogOpen(tagId)),
  
})

export default connect(mapStateToProps, mapDispatchToProps)(RightDrawer);


// WEBPACK FOOTER //
// ./src/components/Drawers/RightDrawer.tsx